import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useParams } from "react-router-dom";
import GenericTable from "../../components/0. Tablas/CursoTable";
import ActividadesView from "../../components/1.3 actividades/Actividad";
import LoadingOverlay from "../../components/0. Utilidades/LoadingOverlay";

const ActividadPage = () => {
  const { id } = useParams();
  const [selectedActividad, setSelectedActividad] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);

  useEffect(() => {
    if (id) {
      setLoadingDetail(true);
      fetch(`${process.env.REACT_APP_BASE_API}api/perfiles/actividades/${id}/`)
        .then((res) => res.json())
        .then((data) => {
          setSelectedActividad(data);
          setShowModal(true); // <-- ADD THIS
          setLoading(false);
        })
        .catch((err) => {
          console.error("Error:", err);
          setLoading(false);
        })
        .finally(() => setLoadingDetail(false));
    } else {
      setLoading(false);
    }
  }, [id]);

  const handleActividadSelect = (actividad) => {
    setLoadingDetail(true);
    setShowModal(false);
    setSelectedActividad(null);

    fetch(
      `${process.env.REACT_APP_BASE_API}api/perfiles/actividades/${actividad.id}/`,
    )
      .then((res) => res.json())
      .then((data) => {
        setSelectedActividad(data);
        setShowModal(true);
      })
      .catch((err) => console.error("Error:", err))
      .finally(() => setLoadingDetail(false));
  };

  const columns = [
    { Header: "Nombre", accessor: "nombre" },
    { Header: "Comuna", accessor: "comuna" },
    { Header: "Oficio", accessor: "oficio" },
  ];

  if (loading) return <LoadingOverlay />;

  return (
    <>
      {(loading || loadingDetail) && <LoadingOverlay />}
      <div className="actividad-page capsule">
        <GenericTable
          apiUrl={`${process.env.REACT_APP_BASE_API}api/perfiles/tabla/actividades/`}
          columns={columns}
          onRowClick={handleActividadSelect}
          category="actividades"
        />

        {showModal && selectedActividad && (
          <Modal
            show={showModal}
            onHide={() => setShowModal(false)}
            size="xl"
            backdrop="static"
            dialogClassName="modal-100w"
          >
            <Modal.Body className="actividad-detail-modal position-relative">
              <button
                className="btn btn-sm btn-danger position-absolute top-0 end-0 m-3"
                onClick={() => setShowModal(false)}
              >
                &times;
              </button>
              <ActividadesView actividad={selectedActividad} />
            </Modal.Body>
          </Modal>
        )}
      </div>
    </>
  );
};

export default ActividadPage;
